import { defineStore } from 'pinia'
import axios from '@/utils/axios'

export const useReminderStore = defineStore('reminder', {
  state: () => ({
    reminders: [],
    lastFetch: 0,
  }),
  getters: {
    count: (state) => state.reminders.length,
  },
  actions: {
    async fetch(force = false) {
      
      const now = Date.now()
      if (!force && now - this.lastFetch < 30000 && this.reminders.length >= 0 && this.lastFetch) {
        return
      }
      try {
        const res = await axios.get('/reminders/my/created')
        this.reminders = res.data.data || []
        this.lastFetch = now
      } catch (e) {
        console.log(e.message)
      }
    },
  },
})